import { render } from "./Watermark.vue?vue&type=template&id=70ee0723"
import script from "./Watermark.vue?vue&type=script&lang=js"
export * from "./Watermark.vue?vue&type=script&lang=js"

import "./Watermark.vue?vue&type=style&index=0&id=70ee0723&lang=scss"
script.render = render

export default script